'use client';

import React__default from 'react';
import { colors } from '../../Colors/index.js';

var VerticalIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 24 : _b, _c = _a.height, height = _c === void 0 ? 24 : _c, _d = _a.color, color = _d === void 0 ? colors.grey[50] : _d;
    return (React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 24 24', fill: 'none' },
        React__default.createElement("path", { d: 'M13.666 5.33325C13.666 4.22859 12.7707 3.33325 11.666 3.33325C10.5613 3.33325 9.66602 4.22859 9.66602 5.33325C9.66602 6.43792 10.5613 7.33325 11.666 7.33325C12.7707 7.33325 13.666 6.43792 13.666 5.33325ZM13.666 11.9999C13.666 10.8953 12.7707 9.99992 11.666 9.99992C10.5613 9.99992 9.66602 10.8953 9.66602 11.9999C9.66602 13.1046 10.5613 13.9999 11.666 13.9999C12.7707 13.9999 13.666 13.1046 13.666 11.9999ZM13.666 18.6666C13.666 17.5619 12.7707 16.6666 11.666 16.6666C10.5613 16.6666 9.66602 17.5619 9.66601 18.6666C9.66601 19.7712 10.5613 20.6666 11.666 20.6666C12.7707 20.6666 13.666 19.7712 13.666 18.6666Z', fill: color })));
};
var VerticalIcon$1 = React__default.memo(VerticalIcon);

export { VerticalIcon$1 as default };
//# sourceMappingURL=Vertical.js.map
